import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { HeaderPageWrapper } from 'components/templates/HeaderPageWrapper/HeaderPageWrapper';
import { Footer } from 'components/molecules/Footer';
import { AskAssociationPanel } from 'components/molecules/AskAssociation/AskAssociationPanel';
import { hasAskAssociationAccessSelector, userFetchedSelector } from 'modules/user/selectors';
import { getPath } from 'utils';
import { Routes } from 'constants/index';

// Full-page AskAssociation experience (replaces the slide-in overlay). The chat
// shell sizes itself to fill the viewport between the header and the footer and
// scrolls internally, so the page itself never scrolls.
//
// Even though SecureRoute already blocks logged-out users, a logged-in user without
// AskAssociation access must not reach the page by typing the URL. Uses the same
// hasAskAssociationAccessSelector as the header button, so the two can't drift out
// of sync. Only redirect once the profile (roles) has loaded, so an eligible user
// isn't bounced during the getMyProfile round-trip on a direct load/refresh.
export const PageAskAssociation: React.FC = () => {
  const hasAccess = useSelector(hasAskAssociationAccessSelector);
  const userFetched = useSelector(userFetchedSelector);

  if (userFetched && !hasAccess) {
    return <Redirect to={getPath(Routes.FEED)} />;
  }

  return (
    <HeaderPageWrapper>
      <AskAssociationPanel asPage />
      <Footer />
    </HeaderPageWrapper>
  );
};
